import _toConsumableArray from "/builds/1-Ndk5Hm/0/webservices/sites/dental-dna-cigna-com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import $ from 'jquery';
import { initClickTracking } from './click-tracking';
import config from './util/config';
import renderTemplate from './util/template';
import svgTemplate from './views/svg.tpl.html';
var isExternalLinkFunc;
var componentsSvg = "".concat(config.svgPath, "component-sprite.svg");
var icons = {
  action: 'chevron-circle-right',
  actionInverted: 'chevron-circle-right-inverted',
  external: 'external-link',
  secure: 'lock'
};
var engLabels = {
  external: 'external site',
  secure: 'secure site'
};
var esLabels = {
  external: 'sitio externo',
  secure: 'sitio seguro'
};
var hidden = {
  action: 'true',
  actionInverted: 'true',
  external: 'false',
  secure: 'false'
}; // types external, secure, action

var addLinkSVG = function addLinkSVG(link, type) {
  var svgLabels = location.href.includes('es-us') ? esLabels : engLabels;
  var svg = renderTemplate(svgTemplate, {
    cls: type,
    svgSpritePath: componentsSvg,
    icon: icons[type],
    label: svgLabels[type],
    hidden: hidden[type]
  }); // TODO: is this reliable? Check if text-nowrap already exists?

  var words = link.html().split(/\s+/);
  var lastWord = words.pop();
  var firstPart = words.join(' '); // Checks if the icon is already present and not a button

  if (link.find("svg.".concat(type)).length === 0) {
    if (link.hasClass('featured-topic') || link.hasClass('btn')) {
      link.append(svg);
    } else if (link.find("svg.".concat(type)).length === 0) {
      if (link.find('span.text-md-nowrap').length === 0) {
        link.html("".concat(firstPart, " <span class=\"text-md-nowrap\">").concat(lastWord).concat(svg, "</span>"));
      } else {
        link.find('span.text-md-nowrap').append(svg);
      }
    }
  }
}; // eslint-disable-next-line no-unused-vars


export var isExternal = function isExternal(link, href, hostname) {
  return (// eslint-disable-next-line implicit-arrow-linebreak
    $.trim(link.text()).length // is not an icon or image
    && href.includes('//')
  );
}; // not internal
// Security concern: https://mathiasbynens.github.io/rel-noopener/ for target="_blank"

var sanatizeTargetBlank = function sanatizeTargetBlank(rel) {
  var parts = new Set((rel || '').split(' '));
  parts.add('noopener');
  parts.add('noreferrer');
  return _toConsumableArray(parts).join(' ').trim();
};

export var initActionLinks = function initActionLinks() {
  $('a.link-action').each(function (index, el) {
    return addLinkSVG($(el), 'action');
  });
  $('a.link-action-inverted').each(function (index, el) {
    return addLinkSVG($(el), 'actionInverted');
  });
};
export var initBlankLinks = function initBlankLinks() {
  $('[target=_blank]').each(function (index, el) {
    el = $(el);
    el.attr('rel', sanatizeTargetBlank(el.attr('rel')));
  });
};
export var initExternalLinks = function initExternalLinks() {
  var addIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (!isExternalLinkFunc) {
    isExternalLinkFunc = isExternal;
  }

  $('a:not(.link-external)').each(function (index, el) {
    el = $(el);
    var href = el.attr('href') || '';

    var _el$get = el.get(0),
        hostname = _el$get.hostname;

    if (isExternalLinkFunc(el, href, hostname) && $.trim(el.text()).length) {
      el.addClass('link-external');
    }
  });
  $('a.link-external').each(function (index, el) {
    el = $(el);
    el.attr('target', '_blank');

    if (addIcon) {
      addLinkSVG(el, 'external');
    }
  });
  initBlankLinks();
};
export var initSecureLinks = function initSecureLinks() {
  $('a.link-secure').each(function (index, el) {
    return addLinkSVG($(el), 'secure');
  });
};
export var setExternalLinkChecker = function setExternalLinkChecker(isExternalFunc) {
  isExternalLinkFunc = isExternalFunc;
};
export var initPdfLinks = function initPdfLinks() {
  $('a[href*=".pdf"]').each(function (index, el) {
    if (el.text !== '' && el.text.indexOf('[PDF]') < 0) {
      $(el).append(' [PDF]');
    }
  });
};
export default (function () {
  initPdfLinks();
  initExternalLinks();
  initSecureLinks();
  initActionLinks();
  initClickTracking();
});